const ERRORS = {
    "E0000001": "login: An object with this field already exists in the current organization",
    "E0000004": "Please enter valid credentials",
    "XP001": "User already exists",
    "XP002": "Please try another password",
    "default": "Something went wrong, please try again",
};

export { ERRORS };
